import {
    productDataViewSelector,
    productListYmmdSelector,
    ymmdSelector,
} from "@store/Store/Components/RsswYMMD/RsswYMMDSelector";
import { useSelector } from "react-redux";

export const useYMMD = () => {
    return useSelector(ymmdSelector);
};

export const useProductListYmmdPage = () => {
    return useSelector(productListYmmdSelector);
};

export const useProductDataView = () => {
    return useSelector(productDataViewSelector);
};
